import WidgetCollection from "@src/components/widgets/WidgetCollection/WidgetCollection";
import { IWidgetGroup } from "@src/interface/Widget";
import React from "react";

interface IWidgetGroupProps {
  group: Partial<IWidgetGroup>;
  partialLoad?: boolean;
}

const WidgetGroup = (props: IWidgetGroupProps) => {
  const { group = {}, partialLoad } = props;
  return group ? (
    <WidgetCollection
      list={group?.collection_list || []}
      group={group}
      partialLoad={partialLoad}
    />
  ) : null;
};

export default WidgetGroup;
